(function () {
    "use strict";

    const SIZES = {
        wordmark: {
            xs: {
                height: 8,
                width: 71
            },
            sm: {
                height: 11,
                width: 97
            },
            md: {
                height: 14,
                width: 124
            },
            lg: {
                height: 18,
                width: 159
            },
            xl: {
                height: 24,
                width: 205
            }
        },
        monogram: {
            xs: {
                height: 16,
                width: 16
            },
            sm: {
                height: 22,
                width: 22
            },
            md: {
                height: 28,
                width: 28
            },
            lg: {
                height: 38,
                width: 38
            },
            xl: {
                height: 50,
                width: 50
            }
        }
    };

    // @ngInject
    function NewHbLogoComponentControllerFunc($injector, $scope, uuid4) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'NewHbLogoComponentController';

        this._type = SIZES[this.type] || SIZES['wordmark'];
        this.dimensions = this._type[this.size] || this._type['xl'];
        this.fillColor = this.color || '#131416';
        this.svgLink = `https://hbstatic.honeybook.com/assets_system/system_web/logos/logo${this.type === 'monogram' ? '_monogram' : ''}${this.suffix ? this.suffix : ''}.svg`;

        this.maskId = uuid4.generate();
    }

    var NewHbLogoComponentController = Class(Controllers.BaseController, {
        constructor: NewHbLogoComponentControllerFunc,
    });

    Components.NewHbLogo = {
        bindings: {
            color: '@',
            type: '@',
            size: '@',
            suffix: '@'
        },
        controller: NewHbLogoComponentController,
        controllerAs: 'newHbLogoVm',
        name: 'hbNewHbLogo',
        templateUrl: 'angular/app/modules/common/svgs/new_hb_logo/new_hb_logo_directive_template.html',
    };
}());